import { Button } from '@wework/dieter-ui'
import React, { FunctionComponent } from 'react'
import IMTheme from '../../style/IMTheme'

interface FloatButtonProps {
  icon: any
  customStyle?: any
  onClick: () => void
}

const FloatButton: FunctionComponent<FloatButtonProps> = ({
  icon,
  customStyle = {},
  onClick,
}) => {
  return (
    <Button
      icon={icon}
      onClick={onClick}
      style={{
        position: 'absolute',
        width: '40px',
        height: '40px',
        bottom: '40px',
        right: '40px',
        borderRadius: '20px',
        backgroundColor: IMTheme.colors.primary,
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.24)',
        ...customStyle,
      }}
    />
  )
}

export default FloatButton
